import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import {
	Box,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import get from "lodash/get";
import { type ReactElement, useEffect, useState } from "react";
import { backgroundColorDarkTheme } from "../../styles/global.styles";

interface DropdownComponentProps {
	label: string;
	value: any;
	disabled?: boolean;
	optionLabel: string;
	optionValue: string;
	optionIcon?: string;
	errorMessage?: string;
	options: any[];
	additionalButton?: ReactElement;
	onChange: (val: any) => void;
}

/**
 * 🚨 @deprecated ESTE COMPONENTE ESTÁ OBSOLETO E SERÁ REMOVIDO EM BREVE.
 * * Por favor, não utilize este componente para novas telas.
 * Utilize o `DropdownComponentV2` (para listas curtas) ou o `DropdownSearchbleComponent` (para busca)
 * Utilize o 'DropdownMultipleComponent (para listas com vários selecionaveis e busca)'.
 * * @see DropdownComponentV2
 * @see DropdownSearchbleComponent
 * @see DropdownMultipleComponent
 */
const DropdownComponent = ({
	label,
	value,
	onChange,
	optionLabel,
	optionValue,
	optionIcon,
	disabled,
	errorMessage,
	options,
	additionalButton,
}: DropdownComponentProps) => {
	const [selectedItem, setSelectedItem] = useState<any>("");
	const [key, setKey] = useState(0);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (options && value) setSelectedItem(value);
		setKey(10 * Math.random());
	}, [options, value]);
	return (
		<Box sx={{ display: "flex", marginBottom: "24px" }}>
				<FormControl fullWidth key={key} error={!!errorMessage}>
					<InputLabel
						id="simple-select-label"
						sx={{ color: disabled ? "rgb(96,96,96)" : "#fff" }}
					>
						{label}
					</InputLabel>
					<Select
						labelId="simple-select-label"
						id="simple-select"
						value={selectedItem}
						label={label}
						disabled={disabled}
						onOpen={() => setOpen(true)}
						onClose={() => setOpen(false)}
						onChange={({ target: { value } }) => {
							onChange(value);
							setSelectedItem(value);
						}}
						sx={{
							"&.Mui-disabled": {
								backgroundColor: "rgba(0, 0, 0, 0.12)",
							},
						}}
						IconComponent={() =>
							open ? (
								<ArrowDropUp sx={{ color: "#ffffff" }} />
							) : (
								<ArrowDropDown sx={{ color: "#ffffff" }} />
							)
						}
					>
						{options.map((option) => (
							<MenuItem
								sx={{
									backgroundColor: backgroundColorDarkTheme,
									display: "flex",
									flexDirection: "row",
									alignItems: "center",
								}}
								value={get(option, optionValue)}
								key={get(option, optionValue)}
							>
								<Box
									sx={{
										flexDirection: "row",
										display: "flex",
										my: 0,
										py: 0,
										alignItems: "center",
									}}
								>
									{optionIcon && (
										<Typography
											sx={{ mr: 0.5, display: "flex", alignItems: "center" }}
										>
											{get(option, optionIcon)}
										</Typography>
									)}
									<Typography>{get(option, optionLabel)}</Typography>
								</Box>
							</MenuItem>
						))}
					</Select>
					{errorMessage && (
						<Typography fontSize={12} color={"#ff0000"} mt={0.5}>
							{errorMessage}
						</Typography>
					)}
				</FormControl>
				{additionalButton}
			</Box>
	);
};

export default DropdownComponent;
